<template>
    <CadastroPadrao :cabecalho="state.cabecalho" :linhas="state.linhas" :url="state.url" :titulo="state.titulo"
        :limparInput="limparInput" :calculoCodigo="true" :objeto="state.objetoAuxiliar" :calcularCodigo="calcularCodigo"
        :lstObrigatorios="state.lstObrigatorios" :lstObrigatoriosLabel="state.lstObrigatoriosLabel">
        <template v-slot:ficha>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Código
                </label>
                <div class="col inp">
                    <input type="text" class="form-control" v-model="state.objetoAuxiliar.id" disabled>
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Descrição
                </label>
                <div class="col inp">
                    <input type="text" class="form-control" v-model="state.objetoAuxiliar.descricao"
                        placeholder="Descrição">
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Ativo
                </label>
                <div class="col inp">
                    <input type="checkbox" class="form-check-input" v-model="state.objetoAuxiliar.ativo">
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Código Quarto
                </label>
                <div class="col inp">
                    <input type="text" class="form-control" v-model="state.objetoAuxiliar.codigoQuarto">
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Setor
                </label>
                <div class="col inp">
                    <select name="" id="" class="form-select" v-model="state.objetoAuxiliar.setor">
                        <option v-for="s in setor" :key="s" :value="s"> {{ s.descricao }} </option>
                    </select>
                </div>
            </div>
        </template>
    </CadastroPadrao>
</template>

<script setup>
import CadastroPadrao from '@/components/CadastroPadrao.vue';
import store from '@/store/store';
import { reactive, onMounted, computed } from 'vue';

const state = reactive({
    cabecalho: ['Código', 'Descrição', 'Setor', 'Código do Quarto', 'Ativo'],
    linhas: ['id', 'descricao', 'setor', 'codigoQuarto', 'ativo'],
    url: "Quarto",
    titulo: "Cadastro de Quarto",
    objetoAuxiliar: {
        ativo: Boolean()
    },
    lstObrigatorios: ['descricao', 'setor', 'codigoQuarto'],
    lstObrigatoriosLabel: ['Descrição', 'Setor', 'Código do Quarto'],
});
async function limparInput(pObj) {
    if (pObj) {
        state.objetoAuxiliar = pObj;
    } else {
        state.objetoAuxiliar = {};
        let maiorId = 0;
        setor.value.forEach(s => {
            if (maiorId < s.id) {
                maiorId = s.id;
            }
        });
        state.objetoAuxiliar.id = maiorId + 1;
        state.objetoAuxiliar.ativo = true;
    }
}
function calcularCodigo() {
    // if (state.objetoAuxiliar.codigoQuarto.includes('.')) {
    //     let aux = state.objetoAuxiliar.codigoQuarto.indexOf(".");
    //     let tamanho = state.objetoAuxiliar.codigoQuarto.length;
    //     let codigo = `${state.objetoAuxiliar.setor.codigoSetor}`;
    //     for (let i = aux; i < tamanho; i++) {
    //         codigo += state.objetoAuxiliar.codigoQuarto[i];
    //     }
    //     state.objetoAuxiliar.codigoQuarto = codigo;
    // } else {
    //     state.objetoAuxiliar.codigoQuarto = `${state.objetoAuxiliar.setor.codigoSetor}.${state.objetoAuxiliar.codigoQuarto}`;
    // }
    // console.log(state.objetoAuxiliar);
}
const setor = computed(() => {
    return store.state.setores;
});
</script>

<style scoped>
.lbl {
    max-width: 35%;
    line-height: 35px;
}
</style>